import React from 'react';
import { Badge, Btn, Empty, T } from './ui';

/**
 * Version history, newest first, with a restore action.
 *
 * A restore appends a copy rather than rewinding, which is why an entry can say "restored". That
 * matters beyond tidiness: a campaign pinned to some other version is untouched by a restore, and
 * "who changed this back, and when" stays answerable.
 */
const VersionHistory = ({ versions = [], onRestore, onLoadMore, hasMore, busy }) => {
  if (versions.length === 0) {
    return (
      <Empty title="No edits yet">
        This template is showing its approved default copy. The first save creates v1.
      </Empty>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
      {versions.map((version, index) => (
        <div
          key={version.id}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 12,
            padding: '12px 14px',
            border: `1px solid ${T.border}`,
            borderRadius: 10,
            background: index === 0 ? T.primarySoft : T.card
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0 }}>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <strong style={{ fontSize: 13.5, color: T.heading }}>v{version.versionNumber}</strong>
              {index === 0 ? <Badge tone="indigo">Current</Badge> : null}
              {version.restoredFrom ? <Badge tone="slate">Restored</Badge> : null}
            </div>
            <span style={{ fontSize: 12.5, color: T.muted }}>
              {version.createdBy?.name || 'Unknown author'} ·{' '}
              {new Date(version.createdAt).toLocaleString()}
            </span>
            {version.blocks?.title ? (
              <span style={{ fontSize: 12.5, color: T.body }}>“{version.blocks.title}”</span>
            ) : null}
          </div>

          {index !== 0 ? (
            <Btn
              variant="outline"
              disabled={busy}
              onClick={() => onRestore(version.id)}
              style={{ padding: '8px 13px', fontSize: 13 }}
            >
              Restore
            </Btn>
          ) : null}
        </div>
      ))}

      {hasMore ? (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Btn variant="outline" onClick={onLoadMore} disabled={busy}>
            Older versions
          </Btn>
        </div>
      ) : null}
    </div>
  );
};

export default VersionHistory;
